export enum PaymentConstants {
  VEHICLE_PAYMENT_TYPE = "VEHICLE_PAYMENT",
  CONTRACT_PAYMENT_TYPE = "CONTRACT_PAYMENT",
}
